import { render, staticRenderFns } from "./QuoteDivider.vue?vue&type=template&id=d865a3d2&scoped=true"
import script from "./QuoteDivider.vue?vue&type=script&lang=js"
export * from "./QuoteDivider.vue?vue&type=script&lang=js"
import style0 from "./QuoteDivider.vue?vue&type=style&index=0&id=d865a3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d865a3d2",
  null
  
)

export default component.exports